/**
 * FlyFreely API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.16.7
 * Contact: support@flyfreely.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SimplePersonDto } from './simplePersonDto';


/**
 * Holds the latest approval for easy reference
 */
export interface RequestersMissionApprovalDto { 
    /**
     * The unique ID of the approval
     */
    id: number;
    /**
     * The current status of the approval
     */
    status: RequestersMissionApprovalDto.Status;
    /**
     * A message from the approver to the RPIC when approving the mission
     */
    messageFromApprover?: string;
    /**
     * The maximum permitted height of operations in feet
     */
    maximumHeight?: number;
    /**
     * The time that the approval was originally requested
     */
    requestTime?: string;
    requestedBy?: SimplePersonDto;
    /**
     * The time the approval was either approved or cancelled
     */
    resolutionTime?: string;
    approvedBy?: SimplePersonDto;
    /**
     * A list of conditions imposed by the approver
     */
    conditions?: Array<string>;
    acceptedBy?: SimplePersonDto;
    /**
     * The time that the approval was accepted
     */
    acceptTime?: string;
    rpicSignature?: string;
    approverSignature?: string;
    authorityWorkflowVersionId: number;
    authorityId: number;
}
export namespace RequestersMissionApprovalDto {
    export type Status = 'DRAFT' | 'PENDING' | 'BEING_REVIEWED' | 'REVISION_REQUIRED' | 'APPROVED' | 'REJECTED' | 'CANCELLED' | 'ACCEPTED' | 'REVOKED';
    export const Status = {
        DRAFT: 'DRAFT' as Status,
        PENDING: 'PENDING' as Status,
        BEING_REVIEWED: 'BEING_REVIEWED' as Status,
        REVISION_REQUIRED: 'REVISION_REQUIRED' as Status,
        APPROVED: 'APPROVED' as Status,
        REJECTED: 'REJECTED' as Status,
        CANCELLED: 'CANCELLED' as Status,
        ACCEPTED: 'ACCEPTED' as Status,
        REVOKED: 'REVOKED' as Status
    };
}



